// Components
import LoginWrapper from "components/molecules/Login/Login";
import ToggleTypeIcon from "components/molecules/ToggleTypeIcon/ToggleTypeIcon";
import { Form, Input, Button } from "antd";
import { Link } from "react-router-dom";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";
import { useLogin } from "containers/Login/useLogin";
import getIcon, { IconProps } from "utils/getIcon";
import { Head } from "components/molecules/Head/Head";
import Spinner from "components/atoms/Spinner/Spinner";
import FirstTimeLogin from "containers/FirstTimeLogin/FirstTimeLogin";
import LoginVerification from "containers/LoginVerification/LoginVerification";

// Styles
import styles from "containers/Login/logIn.module.css";

// Constants
import { LoginPage as LoginPageConstants, PageTitles, Routes } from "constants/global";

const Icon = (props: IconProps) => getIcon({ ...props });

const LoginPage = () => {
	const [form] = Form.useForm();
	const componentProps = useLogin();
	const { sessionTimeoutErr, changingPW, setupOTP, loading, inputType, errors, loginError, firstTimeLoginProps, loginVerificationProps, toggleType, handleSubmit } = componentProps;

	if (loading) {
		return <Spinner />;
	}

	const LoginFlow = () => (
		<LoginWrapper showDesign={true} isSubHeader={true} subHeader={LoginPageConstants?.SUB_HEADER}>
			<div className={styles?.login_form}>
				<Head>{PageTitles.LOGIN}</Head>
				{sessionTimeoutErr && <span className={styles?.form_err}>{LoginPageConstants?.SESSION_TIMEOUT_ERR}</span>}
				{errors?.credentialsErr && <span className={styles?.form_err}>{LoginPageConstants?.CREDENTIAL_ERR}</span>}
				{errors?.attemptsErr && <span className={styles?.form_err}>{LoginPageConstants?.ATTEMPTS_ERR}</span>}
				{loginError ? <span className={styles?.form_err}>{LoginPageConstants?.LOGIN_ERR}</span> : ""}
				{errors?.disabledUserErr ? <span className={`flex justify-center items-center ${styles?.form_err}`}>{LoginPageConstants?.USER_DISABLED_ERR}</span> : ""}
				<Form form={form} name="register" onFinish={handleSubmit} initialValues={{}} scrollToFirstError>
					<Form.Item
						name="username"
						label=""
						tooltip={LoginPageConstants.USERNAME_HINT}
						className={styles?.username_label}
						rules={[
							{
								required: true,
								message: <ErrorMessage message={`Please input ${LoginPageConstants?.USERNAME_HINT}`} />,
								whitespace: false
							}
						]}
					>
						<Input placeholder={LoginPageConstants.USERNAME_HINT} className={styles?.username} suffix={<Icon height="14px" width="14px" icon="userAvatar" />} />
					</Form.Item>
					<Form.Item
						name="password"
						label=""
						rules={[
							{
								required: true,
								message: <ErrorMessage message={"Please input your password!"} />
							}
						]}
					>
						<Input
							suffix={<ToggleTypeIcon toggleType={toggleType} classes={styles?.icon_render} />}
							type={inputType}
							placeholder={LoginPageConstants.WATCHWORD_HINT}
							className={styles?.password}
						/>
					</Form.Item>

					<Form.Item>
						<div className={styles?.center}>
							<Button className={styles?.submit_button} type="primary" htmlType="submit">
								{LoginPageConstants.LOGIN_BTN_TEXT}
							</Button>
						</div>
					</Form.Item>
				</Form>
				<div className={styles?.center}>
					<Link className={styles?.forgot_password} to={Routes?.FORGOT_WATCHWORD}>
						{LoginPageConstants.FORGOT_WATCHWORD_TEXT}
					</Link>
				</div>
			</div>
		</LoginWrapper>
	);

	const componentToRender = !changingPW ? <LoginFlow /> : <FirstTimeLogin firstTimeLoginProps={firstTimeLoginProps} />;

	return <>{!setupOTP ? componentToRender : <LoginVerification loginVerificationProps={loginVerificationProps} />}</>;
};

export default LoginPage;
